export var TransactionTriggerProcessType;
(function (TransactionTriggerProcessType) {
    TransactionTriggerProcessType["PURCHASE"] = "PURCHASE";
    TransactionTriggerProcessType["SPEND"] = "SPEND";
    TransactionTriggerProcessType["TRANSFER"] = "TRANSFER";
    TransactionTriggerProcessType["EARN"] = "EARN";
    TransactionTriggerProcessType["CAMPAIGN_USER_CLAIM"] = "CAMPAIGN_USER_CLAIM";
    TransactionTriggerProcessType["CAMPAIGN_SYSTEM_CLAIM"] = "CAMPAIGN_SYSTEM_CLAIM";
    TransactionTriggerProcessType["CAMPAIGN_BUSINESS_CLAIM"] = "CAMPAIGN_BUSINESS_CLAIM";
    TransactionTriggerProcessType["REDEMPTION_SPEND"] = "REDEMPTION_SPEND";
    TransactionTriggerProcessType["REDEMPTION_RECEIVE"] = "REDEMPTION_RECEIVE";
    TransactionTriggerProcessType["MIGRATION"] = "MIGRATION";
    TransactionTriggerProcessType["ADMIN_TRIGGERED"] = "ADMIN_TRIGGERED";
})(TransactionTriggerProcessType || (TransactionTriggerProcessType = {}));
//# sourceMappingURL=transaction-trigger-process-type.enum.js.map